import { Home } from 'views/website/home';
import { Contact } from 'views/website/contact';
import { Pricing } from 'views/website/pricing';
import { Terms } from 'views/website/terms';
import { Privacy } from 'views/website/privacy';

const Routes = [
  {
    path: '/',
    view: Home,
    layout: 'appDark',
    title: 'Welcome to Scribe'
  },
  {
    path: '/contact',
    view: Contact,
    layout: 'appDark',
    title: 'Contact'
  },
  {
    path: '/pricing',
    view: Pricing,
    layout: 'appDark',
    title: 'Pricing'
  },
  {
    path: '/privacy',
    view: Privacy,
    layout: 'appDark',
    title: 'Privacy Policy'
  },
  {
    path: '/terms',
    view: Terms,
    layout: 'appDark',
    title: 'Terms & Conditions'
  },
]

export default Routes;